export const BILLING_FIELD_DEFS = [
  { label: 'Invoice company name', name: 'invoiceCompanyName', section: 7 },
  { label: 'Billing contact name', name: 'billingContactName', section: 7 },
  { label: 'Billing contact title', name: 'billingContactTitle', section: 7 },
  { label: 'Billing email(s)', name: 'billingEmail', section: 7 },
  { label: 'Address line 1', name: 'addressLine1', section: 7 },
  { label: 'Address line 2', name: 'addressLine2', section: 7 },
  { label: 'City', name: 'city', section: 7 },
  { label: 'Country', name: 'country', section: 7 },
  { label: 'State / region', name: 'state', section: 7 },
  { label: 'Postal code', name: 'postalCode', section: 7 },
];

export const BILLING_FIELD_NAMES = BILLING_FIELD_DEFS.map((field) => field.name);
